enum MessagingReceiverType {
  UNKNOWN = 'UNKNOWN',
  GROUP = 'GROUP',
  GROUP_MEMBERS = 'GROUP_MEMBERS',
  PERSON = 'PERSON',
}

export default MessagingReceiverType;
